<template>
<div class="container1">
    <!-- <div class="class0"><img src="../../assets/img/error/error.gif" style="width:200px"></div> -->
    <div class="class0" style="font-size:80px;margin-top:100px;font-family:Arial;letter-spacing:2px">Error<br><br><br></div>
    <div class="class1">您扫描的二维码已超时<br>
        <div class="class11"><el-button size="medium" @click="click1()" type="warning">&nbsp;&nbsp;登录账户&nbsp;&nbsp;</el-button>  进行延时操作或<el-button @click="click2()" type="warning">&nbsp;&nbsp;升级套餐&nbsp;&nbsp;</el-button></div></div>
    <div class="class2">联系电话：010-82333641<br> 
                            联系邮箱：jvshikeji@163.com<br>
                            <a href="/">美钥码首页</a></div>
</div>
</template>

<script>
export default {
  methods: {
    click1 () {
      this.$router.push('/user/login')
    },
    click2 () {
      this.$router.push('/price')
    }
  }
}
</script>

<style scoped>
.container1 {
  /* background-color:#ea7b68; */
  color: #fff;
  background-image: url('../../assets/img/cases/back1.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 100%;
  bottom: 10px;
  overflow: hidden;
  text-align: center;
  line-height: 40px;
}
.class1 {
  font-size: 25px;
  font-weight: bold;
  line-height: 40px;
}
.class11 {
  margin-top: 10px;
  font-size: 15px;
  font-weight: normal;
}
.class2 {
  font-size: 16px;
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 10px;
  line-height: 30px;
}
@media (max-width: 400px) {
  .class0 {
    margin-top: 50px;
  }
}
</style>
